module.exports = __webpack_public_path__ + "img/header.b6696a33.png";